import { defineMessages } from 'react-intl-next';

export const messages: {
	eventLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eventLabel: {
		id: 'search-graph-dashboard.dashboard-label',
		defaultMessage: 'Dashboard',
		description: 'Dashboard subtype label',
	},
});
